import React, { Component } from "react";
import Selectfield from "../../components/atom/selectfield/Selectfield";
import Textfield from "../../components/atom/textfield/Textfield";
import Button from "../../components/atom/button/Button";
import Textarea from "../../components/atom/textarea/Textarea";
import UncontrolledLottie from "../../components/atom/lottie/UncontrolledLottie";
import contact from "../../assets/lotties/contact/anim--icon-contact";
import { sendContactMail } from "../../data/api";
import { AppContext } from "../../data/ContextProvider";
import t from "../../helpers/t9n";

class ContactPublic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      formData: {},
      projectId: null,
    };
  }

  handleReset = () => {
    this.setState({
      formData: {},
    });
  };

  handleContactMail = (e) => {
    e.preventDefault();
    const data = { ...this.state.formData };
    const isSupport = this.state.formData.reason === "help3";
    const res = sendContactMail(isSupport, data, this.state.projectId);
    res
      .then((res) => {
        this.context.toggleModalInfo(false, t("contact.page.success"));
        this.handleReset();
        setTimeout(() => {
          window.location = `/${window.currentLang}`
        }, 4000)
      })
      .catch((error) => {
        this.context.toggleModalInfo(true);
      });
  };

  handleChange = (e) => {
    if (e.target) {
      const name = e.target.name;
      const value = e.target.value;
      const state = this.state;
      state.formData[name] = value;
      this.setState({ ...state });
    }
  };

  async componentDidMount() {
    setTimeout(() => {
      this.handleReset();
    }, 10);

    const p = this.context.getProjectData();
    if (p) {
      this.setState({ projectId: p.id });
    }
    this.setState({ loading: false });
  }

  render() {
    if (this.state.loading) {
      return "Loading...";
    }

    const project = this.context.getProjectData()
    let contact_info = t("contact.page.info")

    if (project.contact_options && project.contact_options.length) {
      contact_info = project.contact_options
    }

    return (
      <>
        <div className="content contact">
          <span className="contact__header">
            <UncontrolledLottie animationData={contact} />
          </span>
          <div className="contact__content">


              <div className="contact__form">
                <form onSubmit={(e) => this.handleContactMail(e)}>
                  <div
                    className={
                      "login__columns--wrapper login__columns--wrapper--step2"
                    }
                  >
                    <div className={"login__row"}>
                      <div className={"login__col"}>
                        <Selectfield
                          label={t("app.salutation")}
                          options={{
                            herr: t("app.mr"),
                            frau: t("app.ms"),
                            dr: t("app.dr"),
                          }}
                          name={"salutation"}
                          onSelect={(e) => this.handleChange(e)}
                          isRequired={true}
                          placeholder={t("app.salutation")}
                        />
                      </div>
                    </div>
                    <div className={"login__row"}>
                      <div className={"login__col"}>
                        <Textfield
                          label={t("app.firstname")}
                          placeholder={t("app.firstname.placeholder")}
                          isRequired={true}
                          name={"first_name"}
                          handleChange={(e) => this.handleChange(e)}
                        />
                      </div>
                      <div className={"login__col"}>
                        <Textfield
                          label={t("app.lastname")}
                          placeholder={t("app.lastname.placeholder")}
                          name={"last_name"}
                          isRequired={true}
                          handleChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className={"login__row"}>
                      <div className={"login__col"}>
                        <Textfield
                          label={t("app.email")}
                          isRequired={true}
                          placeholder={t("app.email.placeholder")}
                          name={"email"}
                          handleChange={(e) => this.handleChange(e)}
                        />
                      </div>
                      <div className={"login__col"}>
                        <Textfield
                          label={t("app.customer")}
                          isRequired={true}
                          placeholder={t("app.customer.placeholder")}
                          name={"company"}
                          handleChange={(e) => this.handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className={"login__row"}>
                      <div className={"login__col"}>
                        <Textfield
                          label={t("app.phone")}
                          placeholder={t("app.phone.placeholder")}
                          name={"phone"}
                          isRequired={true}
                          handleChange={(e) => this.handleChange(e)}
                        />
                      </div>
                      <div className={"login__col"}>
                        {this.state.formData.reason === "help3" && (
                          <Textfield
                            label={t("contact.page.order.nr")}
                            inputType={"text"}
                            name={"order_number"}
                            isRequired={true}
                            handleChange={(e) => this.handleChange(e)}
                          />
                        )}
                      </div>
                    </div>
                    <div className={"login__row"}>
                      <Textarea
                        label={t("contact.page.message")}
                        placeholder={t("contact.page.message.placeholder")}
                        isRequired={true}
                        name={"message"}
                        handleChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <Button
                      type={"primary"}
                      textColor={"white"}
                      text={t("contact.page.send")}
                    />
                  </div>
                </form>
              </div>


            <div className={"contact__telephone"}>
              <h4>
                {contact_info}
              </h4>
            </div>
          </div>
        </div>
      </>
    );
  }
}

ContactPublic.contextType = AppContext;
export default ContactPublic;
